import React, { useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { SHA256 } from 'crypto-js';
import { API } from 'aws-amplify';
import jwtDecode from 'jwt-decode';
import { getCurrentUserEmail } from '../../utils/auth/authenticatedUser';
import Loader from '../../components/Loader';
import SITE_PATHS from '../../config/sitePaths';
import OAuthError from './OAuth.error.view';

const respondWithInvalidSessionError = () => ({
  error: 'Invalid or expired session.',
});

const getSession = (sessionId) => {
  try {
    const result = JSON.parse(localStorage.getItem(sessionId));
    if (!result) return respondWithInvalidSessionError();
    localStorage.removeItem(sessionId);
    return result;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Corrupt session or possible CRSF attack.', error);
    return respondWithInvalidSessionError();
  }
};

export default function OAuthContainer(props) {
  const {
    resumeWizard,
  } = props;
  const [session, setSession] = useState();
  const params = new URLSearchParams(props.location.search);
  const state = params.get('state');
  const code = params.get('code');
  const authJwtResponse = params.get('response');
  const error = params.get('error');

  const history = useHistory();

  useMemo(() => {
    const sessionId = authJwtResponse ? jwtDecode(authJwtResponse).state : state;
    setSession(getSession(sessionId));
  }, [state, authJwtResponse]);

  useEffect(() => {
    async function fetchData() {
      if (!session || session.error) return;
      const {
        fiId,
        providerId,
        redirectUrl,
        scoringRequest: {
          clientId,
          requestId,
        },
        scoringRequest,
        scoringRequest: {
          trustStartPublicConfig: {
            banking: bankingConfig,
          },
        },
      } = session;
      const userEmail = await getCurrentUserEmail();
      const user = SHA256(userEmail).toString();
      await API.post('Auth', '/', {
        body: {
          user,
          providerId,
          clientId,
          requestId,
          fiId,
          code,
          authJwtResponse,
          redirectUrl,
        },
      });
      resumeWizard(
        SITE_PATHS.BANKING,
        history,
        {
          resumeAuth: {
            providerId,
            fiId,
          },
          bankingConfig,
          scoringRequest,
        },
      );
    }
    fetchData();
  }, [session, authJwtResponse, history, code, resumeWizard]);

  if (error) {
    const message = params.get('error_description') || 'An unexpected error occurred';
    return (
      <OAuthError error={message} />
    );
  }

  if (session?.error) {
    return (
      <OAuthError
        error={session.error}
      />
    );
  }
  return (<Loader />);
}
